/* istanbul ignore file */
// libs
import React from 'react';
import Box from '@mui/material/Box';
import { SxProps, Theme } from '@mui/material/styles';

interface HorizontalMenuProps {
  children: React.ReactNode;
  className?: string;
  sx?: SxProps<Theme>;
}

const HorizontalMenu = ({ children, className, sx = {} }: HorizontalMenuProps) => {
  return (
    <Box className={className} sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'flex-start', mt: 0, ...sx }}>
      {children}
    </Box>
  );
};

export default HorizontalMenu;
